export interface Dimension {
  width: number;
  height: number;
}

export interface Position {
  x: number;
  y: number;
}

export interface Pagination {
  page: number;
  pageSize: number;
  totalPage: number;
  totalSize: number;
}

export interface CellLayout {
  width: number;
  height: number;
  x: number;
  y: number;
  quality: number;
}

export interface MediaDevice {
  label: string;
  deviceId: string;
}

export interface FearureSwitch {
  toggled: boolean;
  enabled: boolean;
}

export interface AdvancedFeatureSwitch {
  adjustVolumn: FearureSwitch;
  farEndCameraControl: FearureSwitch;
}

export interface Participant {
  displayName: string;
  isAllowIndividualRecording: boolean;
  isHost: boolean;
  userGuid: string;
  userId: number;
  userIdentity: string;
}

export interface Conference {
  currentUser: string;
  currentTopic: string;
}

export enum ECameraMenuItemKey {
  camera = 'camera',
  mirror = 'mirror',
  blur = 'blur',
}

export type TCameraMenuItemKey =
  | ECameraMenuItemKey.camera
  | ECameraMenuItemKey.mirror
  | ECameraMenuItemKey.blur;

export enum EMicrophoneMenuItemKey {
  microphone = 'microphone',
  speaker = 'speaker',
  leaveAudio = 'leave audio',
  phone = 'phone',
}

export type TMicrophoneMenuItemKey =
  | EMicrophoneMenuItemKey.microphone
  | EMicrophoneMenuItemKey.speaker
  | EMicrophoneMenuItemKey.leaveAudio
  | EMicrophoneMenuItemKey.phone;

export type VideoMenuItemKey = TCameraMenuItemKey | TMicrophoneMenuItemKey;

export enum EVideoMenuItem {
  group = 'group',
}

export type VideoFooterMenuOptionChild = {
  label: string;
  deviceId: string;
};

export type VideoFooterMenuOption = {
  label: string;
  key?: VideoMenuItemKey;
  children?: VideoFooterMenuOptionChild[];
  activeOption?: string;
  type?: EVideoMenuItem.group;
  isActive?: boolean;
};
